import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import TrainingTable from './TrainingTable';

const TrainingForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [institutes, setInstitutes] = useState([]);
  const [schemes, setSchemes] = useState([]);
  const [states, setStates] = useState([]);
  const [regions, setRegions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [trainings, setTrainings] = useState([]);
  const [titles, setTitles] = useState([]);
  const [fileUploading, setFileUploading] = useState(false);
const [uploadedFilePath, setUploadedFilePath] = useState('');
const [showInstitutionLocation, setShowInstitutionLocation] = useState(false);
const [showExposureLocation, setShowExposureLocation] = useState(false);
  // Add this with your other state declarations at the top of the component
const [autoCalculate, setAutoCalculate] = useState(true); // Default to auto-calculate
  const [showPLCFields, setShowPLCFields] = useState(false);
const [plcData, setPlcData] = useState({
  numberOfPLC: '',
  amount: '',  // ✅ CHANGED from plcAmount
  remarks: '',
  signedCopyFile: ''
});
const [showIECFields, setShowIECFields] = useState(false);
const [iecData, setIecData] = useState({
  iecRemarks: '',
  amount: ''  // ✅ CHANGED from iecAmount
});
const [showHandholdingFields, setShowHandholdingFields] = useState(false);
const [handholdingData, setHandholdingData] = useState({
  numberOfDistricts: '',
  numberOfInstitutions: '',
  amount: '',  // ✅ CHANGED from handholdingAmount
  handholdingRemarks: '',
  handholdingFile: ''
});
const [handholdingFileUploading, setHandholdingFileUploading] = useState(false);
const [plcFileUploading, setPlcFileUploading] = useState(false);
  // PMU state
  const [showPMUFields, setShowPMUFields] = useState(false);
const [pmuData, setPmuData] = useState({
  pmuType: '',
  amount: '',  // ✅ CHANGED from expenditure
  remarks: '',
  pmuFile: ''
});

  const [pmuFileUploading, setPmuFileUploading] = useState(false);
  
  // PMU type options
  const pmuTypes = [
    'Day to Day Expenditure',
    'Accessories',
    'Consumables',
    'Broadband',
    'Stationery',
    'Rent',
    'EB',
    'Daily Wages',
    'Office Assistant',
    'Meeting Expenses',
    'Vehicle Hire Charges'
  ];
  // Clientile state
  const [clientileCategories, setClientileCategories] = useState([]);
  const [selectedClientileOptions, setSelectedClientileOptions] = useState([]);
  
  // Confirmed clientile entries that will be displayed as labels
  const [confirmedClientile, setConfirmedClientile] = useState([]);

  // Single clientile input for simplified approach
  const [clientileInput, setClientileInput] = useState({
    type: '',
    typeLabel: '',
    member: '',
    nos: ''
  });
  
const [formData, setFormData] = useState({
  instituteId: '',
  schemeId: '',
  year: '25s26',
  timePeriod: '2nd-quarter',
  month: '',
  asDate: '',
  asNumber: '',
  titleId: '', 
  trainingId: '', 
  type: '', 
  shortTitle: '', 
  participants: '',
  clientile: '', 
  days: '',
  batches: '',
  amountAllocated: '',
  training: '',
  institutionLocation: '', // ADD THIS LINE
  exposureLocation: ''      // ADD THIS LINE
});
// Institution options for Leadership Management Programme (state role only)
const institutionOptions = [
  'IIM - TRICHY',
  'IRMA - ANAND'
];

// Location options for Exposure Visit - Outside State (state role only)
// Location options for Exposure Visit - Outside State (state role only)
const exposureLocationOptions = [
  'KILA-Kerala',
  'CGG (Telangana)',
  'Odisha',
  'Maharashtra',
  'Hyderabad',
  'Mysuru-SIRD',
  'AP-SIRD Vijayawada',
  'IRMA-ANAND'
];
const [showModuleFields, setShowModuleFields] = useState(false);
const [moduleData, setModuleData] = useState({
  numberOfModules: '',
  amount: '',  // ✅ CHANGED from moduleAmount
  moduleRemarks: '',
  moduleFile: ''
});
const [moduleFileUploading, setModuleFileUploading] = useState(false);
const years = [
  { display: '26-27', withS: '26s27', withoutS: '26-27' }
];
  const currentDate = new Date();
  const currentMonthIndex = currentDate.getMonth();
// Define months for each quarter
const quarterMonths = {
  '1st-quarter': [
    { value: '04', name: 'April' },
    { value: '05', name: 'May' },
    { value: '06', name: 'June' }
  ],
  '2nd-quarter': [
    { value: '07', name: 'July' },
    { value: '08', name: 'August' },
    { value: '09', name: 'September' }
  ],
  '3rd-quarter': [
    { value: '10', name: 'October' },
    { value: '11', name: 'November' },
    { value: '12', name: 'December' }
  ],
  '4th-quarter': [
    { value: '01', name: 'January' },
    { value: '02', name: 'February' },
    { value: '03', name: 'March' }
  ]
};


  // Add this with your other state declarations at the top of the component
const [balanceInfo, setBalanceInfo] = useState(null);
const [balanceLoading, setBalanceLoading] = useState(false);
const [balanceWarning, setBalanceWarning] = useState('');
  // Types dropdown options
  const trainingTypes = [
    "Writeshop",
    "Workshop",
    "Seminar",
    "TOT",
    "Field Visit",
    "Training"
     
    
  ];

  // Get user role from localStorage
  const getUserRole = () => {
    try {
      return localStorage.getItem('userRole') || '';
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      return '';
    }
  };
const handlePMUChange = (field, value) => {
  if (field === 'amount') {  // ✅ CHANGED from 'expenditure'
    const numericValue = value.replace(/\D/g, '');
    setPmuData(prev => ({
      ...prev,
      [field]: numericValue
    }));
  } else {
    setPmuData(prev => ({
      ...prev,
      [field]: value
    }));
  }
};
// Handle PMU file upload
const handlePMUFileUpload = async (file) => {
  if (!file) return;
  
  setPmuFileUploading(true);
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await fetch(`${api.BASE_URL}/admin/upload`, {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('authToken')
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error('Failed to upload file');
    }
    
    const data = await response.json();
    if (data && !data.error) {
      setPmuData(prev => ({
        ...prev,
        pmuFile: data.file
      }));
      alert('File uploaded successfully!');
    } else {
      throw new Error(data.message || 'Upload failed');
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    alert(`Failed to upload file: ${error.message}`);
  } finally {
    setPmuFileUploading(false);
  }
};
// Handholding Handler - CHANGE handholdingAmount to amount
const handleHandholdingChange = (field, value) => {
  if (field === 'numberOfDistricts' || field === 'numberOfInstitutions' || field === 'amount') {  // ✅ CHANGED
    const numericValue = value.replace(/\D/g, '');
    setHandholdingData(prev => ({
      ...prev,
      [field]: numericValue
    }));
  } else {
    setHandholdingData(prev => ({
      ...prev,
      [field]: value
    }));
  }
};

// Handle Handholding file upload
const handleHandholdingFileUpload = async (file) => {
  if (!file) return;
  
  setHandholdingFileUploading(true);
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await fetch(`${api.BASE_URL}/admin/upload`, {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('authToken')
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error('Failed to upload file');
    }
    
    const data = await response.json();
    if (data && !data.error) {
      setHandholdingData(prev => ({
        ...prev,
        handholdingFile: data.file
      }));
      alert('File uploaded successfully!');
    } else {
      throw new Error(data.message || 'Upload failed');
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    alert(`Failed to upload file: ${error.message}`);
  } finally {
    setHandholdingFileUploading(false);
  }
};
  // Calculate amount allocated based on user role and participants/days
// Calculate amount allocated based on user role and participants/days
const calculateAmountAllocated = (participants, days) => {
  try {
    const numParticipants = parseInt(participants) || 0;
    const numDays = parseInt(days) || 0;
    
    // Find the selected title to check if it's Exposure Visit
    const selectedTitleId = formData.titleId;
    if (selectedTitleId) {
      const selectedTitle = titles.find(t => t.id === parseInt(selectedTitleId));
      const isExposureVisit = selectedTitle && selectedTitle.name === "Exposure Visit";
      
      // If this is an Exposure Visit, use the special rate of 3500
      if (isExposureVisit) {
        return (3500 * numParticipants * numDays).toString();
      }
    }
    
    // Otherwise use the original rate based on user role
    const userRole = getUserRole();
    
    if (userRole === 'state') {
      // For state: 2500 * participants * days
      return (2500 * numParticipants * numDays).toString();
    } else if (userRole === 'region') {
      // For region: 1500 * participants * days
      return (1500 * numParticipants * numDays).toString();
    } else {
      // For district: 1000 * participants * days
      return (1000 * numParticipants * numDays).toString();
    }
  } catch (error) {
    console.error('Error calculating amount:', error);
    return '0';
  }
};


// Show/hide institution location and exposure location based on title selection and user role
useEffect(() => {
  const userRole = getUserRole();
  
  if (userRole === 'state' && formData.titleId) {
    const selectedTitle = titles.find(t => t.id === parseInt(formData.titleId));
    
    if (selectedTitle) {
      // Check if title is "Leadership Management Programme"
      if (selectedTitle.name === 'Leadership Management Programme') {
        setShowInstitutionLocation(true);
        setShowExposureLocation(false);
        setFormData(prev => ({
          ...prev,
          exposureLocation: '' // Clear exposure location
        }));
      } 
      // Check if title is "Exposure Visit - Outside State"
      else if (selectedTitle.name === 'Exposure Visit-Outside State') {
        setShowExposureLocation(true);
        setShowInstitutionLocation(false);
        setFormData(prev => ({
          ...prev,
          institutionLocation: '' // Clear institution location
        }));
      } 
      // For any other title
      else {
        setShowInstitutionLocation(false);
        setShowExposureLocation(false);
        setFormData(prev => ({
          ...prev,
          institutionLocation: '',
          exposureLocation: ''
        }));
      }
    }
  } else {
    // If not state role, hide both fields
    setShowInstitutionLocation(false);
    setShowExposureLocation(false);
  }
}, [formData.titleId, titles]);
// Show/hide PLC fields based on title selection and user role
// Update the existing PLC useEffect
useEffect(() => {
  const userRole = getUserRole();
  
  if (userRole === 'state' && formData.titleId) {
    const selectedTitle = titles.find(t => t.id === parseInt(formData.titleId));
    
    if (selectedTitle && selectedTitle.name === 'Development of Panchayat Learning Center (PLC)') {
      setShowPLCFields(true);
      setShowModuleFields(false); // ADD THIS LINE
      // Hide other fields when PLC is selected
      setShowInstitutionLocation(false);
      setShowExposureLocation(false);
    } else {
      setShowPLCFields(false);
      // Reset PLC data when switching away from PLC
      setPlcData({
        numberOfPLC: '',
        plcAmount: '',
        remarks: '',
        signedCopyFile: ''
      });
    }
  } else {
    setShowPLCFields(false);
  }
}, [formData.titleId, titles]);
  useEffect(() => {
    const fetchTitles = async () => {
      if (!formData.schemeId) return;
      
      setLoading(true);
      try {
        // Similar to what's in the InfrastructureForm
        const titlesData = await api.master.getTrainingTitles(formData.schemeId);
        
        if (titlesData && !titlesData.error) {
          setTitles(titlesData.data || []);
        }
      } catch (error) {
        console.error('Error fetching training titles:', error);
        alert('Failed to load training titles. Please check your connection and try again.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchTitles();
  }, [formData.schemeId]);

  

  // Set the appropriate institute based on user role
  const setInstituteBasedOnRole = (instituteList) => {
    const userRole = getUserRole();
    
    if (!instituteList || instituteList.length === 0) return;
    
    let selectedInstitute = null;
    
    if (userRole === 'state') {
      selectedInstitute = instituteList.find(inst => inst.code === 'SIR' || inst.name === 'SIRD');
    } else if (userRole === 'region') {
      selectedInstitute = instituteList.find(inst => inst.code === 'RIR' || inst.name === 'RIRD');
    } else if (userRole === 'district') {
      selectedInstitute = instituteList.find(inst => inst.code === 'DRC' || inst.name === 'DRCP');
    }
    
    if (selectedInstitute) {
      setFormData(prevData => ({
        ...prevData,
        instituteId: selectedInstitute.id.toString()
      }));
    }
  };

  // Add a clientile entry
  const addClientileEntry = () => {
    // Validate the entry
    if (!clientileInput.type || !clientileInput.member || !clientileInput.nos) {
      alert('Please fill all Clientele fields (Type, Member, and Nos) before adding.');
      return;
    }
    
    // Create a new entry with a unique ID
    const newId = confirmedClientile.length > 0 
      ? Math.max(...confirmedClientile.map(entry => entry.id)) + 1 
      : 1;
    
    const newEntry = {
      ...clientileInput,
      id: newId
    };
    
    // Add to confirmed list
    const updatedEntries = [...confirmedClientile, newEntry];
    setConfirmedClientile(updatedEntries);
    
    // Update the clientile field in formData
    setFormData(prev => ({
      ...prev,
      clientile: JSON.stringify(updatedEntries)
    }));
    
    // Reset the input form
    setClientileInput({
      type: '',
      typeLabel: '',
      member: '',
      nos: ''
    });
  };

  // Remove a confirmed clientile entry
  const removeConfirmedClientile = (id) => {
    const updatedEntries = confirmedClientile.filter(entry => entry.id !== id);
    setConfirmedClientile(updatedEntries);
    
    // Update the clientile field in formData
    setFormData(prev => ({
      ...prev,
      clientile: JSON.stringify(updatedEntries)
    }));
  };
// Add this function after calculateAmountAllocated
// Add this function after calculateAmountAllocated
// Add this function after calculateAmountAllocated
// Replace your current checkBalance function with this one
// Replace your current checkBalance function with this corrected version
const checkBalance = async (calculatedAmount) => {
  if (!calculatedAmount || calculatedAmount === '0') return;
  
  setBalanceLoading(true);
  setBalanceWarning('');
  
  try {
    // Use the existing API service
    const balanceData = await api.ledger.getBalance();
    
    if (balanceData && !balanceData.error && balanceData.data && balanceData.data.length > 0) {
      const currentBalance = parseFloat(balanceData.data[0].balance);
      const requestedAmount = parseFloat(calculatedAmount);
      
      console.log('Balance Check:', {
        currentBalance,
        requestedAmount,
        balanceData: balanceData.data[0]
      });
      
      // Check if requested amount exceeds available balance
      if (requestedAmount > currentBalance) {
        setBalanceWarning(`Warning: Requested amount (₹${requestedAmount.toLocaleString()}) exceeds available balance (₹${currentBalance.toLocaleString()})`);
      } else if (currentBalance < 0) {
        // Also check if balance itself is negative
        setBalanceWarning(`Warning: Insufficient balance. Current balance is ₹${currentBalance.toLocaleString()}`);
      } else {
        setBalanceWarning(''); // Clear warning if amount is within available balance
      }
      
      setBalanceInfo(balanceData.data[0]);
    }
  } catch (error) {
    console.error('Error checking balance:', error);
    setBalanceWarning('Could not verify balance. Please check manually.');
  } finally {
    setBalanceLoading(false);
  }
};
 const handleFileUpload = async (file) => {
  if (!file) return;
  
  setFileUploading(true);
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await fetch(`${api.BASE_URL}/admin/upload`, {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('authToken')
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error('Failed to upload file');
    }
    
    const data = await response.json();
    if (data && !data.error) {
      setUploadedFilePath(data.file);
      alert('File uploaded successfully!');
    } else {
      throw new Error(data.message || 'Upload failed');
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    alert(`Failed to upload file: ${error.message}`);
  } finally {
    setFileUploading(false);
  }
}; // Fetch institutes, schemes, trainings, and clientile categories on component mount
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Get institute, scheme, and training data using the API service
        const institutesData = await api.master.getInstitutes();
        const schemesData = await api.master.getSchemes();
        const trainingsData = await api.master.getTrainings();
        
        // Fetch clientile categories
        const clientileResponse = await fetch(`${api.BASE_URL}/master/clientele`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('authToken')
          }
        });
        
        const clientileData = await clientileResponse.json();
        
        if (institutesData && !institutesData.error) {
          setInstitutes(institutesData.data);
          setInstituteBasedOnRole(institutesData.data);
        }
        
        if (schemesData && !schemesData.error) {
          setSchemes(schemesData.data);
        }
        
        if (trainingsData && !trainingsData.error) {
          setTrainings(trainingsData.data);
        }
        
        if (clientileData && !clientileData.error) {
          setClientileCategories(clientileData.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        alert('Failed to load data. Please check your connection and try again.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

// Initialize the form on component mount
useEffect(() => {
  setFormData(prevData => ({
    ...prevData,
    clientile: JSON.stringify([]) // Initialize clientile JSON as empty array
  }));
}, []);
// Reset month and update year when time period changes
useEffect(() => {
  setFormData(prevData => ({
    ...prevData,
    month: '',
    year: '26-27'
  }));
}, [formData.timePeriod]);
// Show/hide PLC, Module, or IEC fields based on title selection and user role
// Show/hide PLC, Module, IEC, or Handholding fields based on title selection and user role
useEffect(() => {
  const userRole = getUserRole();
  
  if (userRole === 'state' && formData.titleId) {
    const selectedTitle = titles.find(t => t.id === parseInt(formData.titleId));
    
    if (selectedTitle) {
      // Check for Development of Panchayat Learning Center (PLC)
      if (selectedTitle.name === 'Development of Panchayat Learning Center (PLC)') {
        setShowPLCFields(true);
        setShowModuleFields(false);
        setShowIECFields(false);
        setShowHandholdingFields(false);
        setShowInstitutionLocation(false);
        setShowExposureLocation(false);
      } 
      // Check for Developing Training Modules
      else if (selectedTitle.name === 'Developing Training Modules') {
        setShowModuleFields(true);
        setShowPLCFields(false);
        setShowIECFields(false);
        setShowHandholdingFields(false);
        setShowInstitutionLocation(false);
        setShowExposureLocation(false);
      }
      // Check for Information, Education, and Communication
      else if (selectedTitle.name === 'Information, Education, and Communication') {
        setShowIECFields(true);
        setShowPLCFields(false);
        setShowModuleFields(false);
        setShowHandholdingFields(false);
        setShowInstitutionLocation(false);
        setShowExposureLocation(false);
      }
// Check for Handholding Support for GPDP
      else if (selectedTitle.name === 'Handholding Support for GPDP') {
        setShowHandholdingFields(true);
        setShowPLCFields(false);
        setShowModuleFields(false);
        setShowIECFields(false);
        setShowPMUFields(false);
        setShowInstitutionLocation(false);
        setShowExposureLocation(false);
      }
      // Check for Programme Management Unit
      else if (selectedTitle.name === 'Programme Management Unit') {
        setShowPMUFields(true);
        setShowHandholdingFields(false);
        setShowPLCFields(false);
        setShowModuleFields(false);
        setShowIECFields(false);
        setShowInstitutionLocation(false);
        setShowExposureLocation(false);
      }
    else {
        setShowPLCFields(false);
        setShowModuleFields(false);
        setShowIECFields(false);
        setShowHandholdingFields(false);
        setShowPMUFields(false);
        // Reset data when switching away
setPlcData({
    numberOfPLC: '',
    amount: '',  // ✅ CHANGED from plcAmount
    remarks: '',
    signedCopyFile: ''
  });
  setModuleData({
    numberOfModules: '',
    amount: '',  // ✅ CHANGED from moduleAmount
    moduleRemarks: '',
    moduleFile: ''
  });
  setIecData({
    iecRemarks: '',
    amount: ''  // ✅ CHANGED from iecAmount
  });
  setHandholdingData({
    numberOfDistricts: '',
    numberOfInstitutions: '',
    amount: '',  // ✅ CHANGED from handholdingAmount
    handholdingRemarks: '',
    handholdingFile: ''
  });
  setPmuData({
    pmuType: '',
    amount: '',  // ✅ CHANGED from expenditure
    remarks: '',
    pmuFile: ''
  });
      }
    }
 } else {
    setShowPLCFields(false);
    setShowModuleFields(false);
    setShowIECFields(false);
    setShowHandholdingFields(false);
    setShowPMUFields(false);
  }
}, [formData.titleId, titles]);
  // Effect to calculate amount when both participants and days change// Effect to calculate amount when both participants and days change
// Effect to calculate amount when relevant fields change
useEffect(() => {
  console.log('🔄 useEffect triggered:', {
    autoCalculate,
    participants: formData.participants,
    days: formData.days,
    titleId: formData.titleId
  });
  
  if (autoCalculate && formData.participants && formData.days) {
    const calculatedAmount = calculateAmountAllocated(formData.participants, formData.days);
    console.log('💵 Calculated amount:', calculatedAmount, 'Current amount:', formData.amountAllocated);
    
    setFormData(prevData => ({
      ...prevData,
      amountAllocated: calculatedAmount
    }));
    
    // ALWAYS call checkBalance when amount is calculated - regardless of whether it changed
    console.log('🚀 Calling checkBalance from useEffect');
    checkBalance(calculatedAmount);
  } else {
    console.log('❌ useEffect conditions not met:', {
      autoCalculateOn: autoCalculate,
      hasParticipants: !!formData.participants,
      hasDays: !!formData.days
    });
  }
}, [formData.participants, formData.days, formData.titleId, autoCalculate]);

  // Fetch location data based on selected institute
  useEffect(() => {
    const fetchLocationData = async () => {
      if (!formData.instituteId) return;
      
      setLoading(true);
      try {
        const selectedInstitute = institutes.find(institute => institute.id === parseInt(formData.instituteId));
        if (!selectedInstitute) return;
        
        const instituteName = selectedInstitute.name.toLowerCase();
        
        if (instituteName.includes('sird')) {
          // Fetch states for SIRD
          const statesData = await api.master.getStates();
          if (statesData && !statesData.error) {
            setStates(statesData.data);
          }
        } else if (instituteName.includes('rird')) {
          // Fetch regions for RIRD
          const regionsData = await api.master.getRegions();
          if (regionsData && !regionsData.error) {
            setRegions(regionsData.data);
          }
        } else if (instituteName.includes('drcp')) {
          // Fetch districts for DRCP
          const districtsData = await api.master.getDistricts();
          if (districtsData && !districtsData.error) {
            setDistricts(districtsData.data);
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
        alert('Failed to load location data. Please check your connection and try again.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchLocationData();
  }, [formData.instituteId, institutes]);
// Add this function to handle toggling between auto and manual calculation
const handleToggleAutoCalculate = () => {
  const newAutoCalculate = !autoCalculate;
  setAutoCalculate(newAutoCalculate);
  
  // If switching to auto-calculate, recalculate the amount
  if (newAutoCalculate && formData.participants && formData.days) {
    const calculatedAmount = calculateAmountAllocated(formData.participants, formData.days);
    setFormData(prevData => ({
      ...prevData,
      amountAllocated: calculatedAmount
    }));
    
    // Call balance check when switching to auto-calculate
    checkBalance(calculatedAmount);
  }
};
  // Handle input changes
// Handle input changes
// Handle input changes
const handleChange = (e) => {
  try {
    const { name, value } = e.target;
    
    // Special handling for titleId - auto-fill shortTitle based on selection
    if (name === 'titleId' && value) {
      const selectedTitle = titles.find(t => t.id === parseInt(value));
      if (selectedTitle) {
        const updatedFormData = {
          ...formData,
          [name]: value,
          shortTitle: selectedTitle.code,
          training: selectedTitle.name
        };
        
        // Recalculate amount when title changes if auto-calculate is on and we have participants and days
        if (autoCalculate && formData.participants && formData.days) {
          updatedFormData.amountAllocated = calculateAmountAllocated(formData.participants, formData.days);
          
          // Call balance check when title changes and amount is recalculated
          checkBalance(updatedFormData.amountAllocated);
        }
        
        setFormData(updatedFormData);
        return;
      }
    }
    
    // Special handling for shortTitle to limit to 3 characters
    if (name === 'shortTitle' && value.length > 3) {
      return;
    }
    
    // Handle numeric fields (participants, days, batches)
    if (['participants', 'days', 'batches'].includes(name)) {
      const numericValue = value.replace(/\D/g, '');
      
      // Create updated form data
      const updatedFormData = { ...formData, [name]: numericValue };
      
      // Auto-calculate amount allocated when participants or days change only if autoCalculate is true
      if ((name === 'participants' || name === 'days') && autoCalculate) {
        // Use the updated value for the current field and existing value for the other field
        const daysValue = name === 'days' ? numericValue : formData.days;
        const participantsValue = name === 'participants' ? numericValue : formData.participants;
        
        // Only calculate if both values are present
        if (daysValue && participantsValue) {
          updatedFormData.amountAllocated = calculateAmountAllocated(participantsValue, daysValue);
          
          // Call balance check immediately when amount is calculated
          checkBalance(updatedFormData.amountAllocated);
        }
      }
      
      setFormData(updatedFormData);
      return;
    }
    
    // For amountAllocated, allow manual edits only when autoCalculate is false
    if (name === 'amountAllocated') {
      if (!autoCalculate) {
        // Only allow numeric input for amount
        const numericValue = value.replace(/\D/g, '');
        setFormData({ ...formData, [name]: numericValue });
        
        // Check balance when amount is manually entered
        if (numericValue && numericValue !== '0') {
          checkBalance(numericValue);
        }
      }
      return;
    }
    
    setFormData({ ...formData, [name]: value });
  } catch (error) {
    console.error('Error in handleChange:', error);
  }
};

// PLC Handler - CHANGE plcAmount to amount
const handlePLCChange = (field, value) => {
  if (field === 'numberOfPLC' || field === 'amount') {  // ✅ CHANGED from 'plcAmount'
    const numericValue = value.replace(/\D/g, '');
    setPlcData(prev => ({
      ...prev,
      [field]: numericValue
    }));
  } else {
    setPlcData(prev => ({
      ...prev,
      [field]: value
    }));
  }
};
const handleHandholdingSubmit = async () => {
  setLoading(true);
  
  try {
    const selectedInstitute = institutes.find(institute => institute.id === parseInt(formData.instituteId));
    const selectedScheme = schemes.find(scheme => scheme.id === parseInt(formData.schemeId));
    const center_name = localStorage.getItem('name') || '';
    
    const finalData = {
      institute: selectedInstitute ? selectedInstitute.code : '',
      scheme: selectedScheme ? selectedScheme.code : '',
      scheme_name: selectedScheme ? selectedScheme.name : '',
      title: formData.training,
      year: formData.year,
      month: formData.month,
      asDate: formData.asDate,
      asNumber: formData.asNumber,
      asFile: uploadedFilePath || '',
      center_name: center_name,
      stitle: formData.shortTitle.toUpperCase(),
      type: "training",
      // Handholding specific fields
      numberOfDistricts: handholdingData.numberOfDistricts,
      numberOfInstitutions: handholdingData.numberOfInstitutions,
      amount: handholdingData.amount,  // ✅ CHANGED from handholdingAmount
      handholdingRemarks: handholdingData.handholdingRemarks,
      handholdingFile: handholdingData.handholdingFile || '',
      isHandholding: true
    };
    
    console.log('Submitting Handholding data:', finalData);
    
    const response = await api.training.addTraining(finalData);
    
    if (response && !response.error) {
      alert('Handholding Support training added successfully!');
      navigate('/dashboard');
    } else {
      alert(response.message || 'Error adding Handholding Support training');
    }
  } catch (error) {
    console.error('Error submitting Handholding form:', error);
    alert(error.message || 'Error submitting form. Please try again.');
  } finally {
    setLoading(false);
  }
};
// Module Handler - CHANGE moduleAmount to amount
const handleModuleChange = (field, value) => {
  if (field === 'numberOfModules' || field === 'amount') {  // ✅ CHANGED from 'moduleAmount'
    const numericValue = value.replace(/\D/g, '');
    setModuleData(prev => ({
      ...prev,
      [field]: numericValue
    }));
  } else {
    setModuleData(prev => ({
      ...prev,
      [field]: value
    }));
  }
};
// IEC Handler - CHANGE iecAmount to amount
const handleIECChange = (field, value) => {
  if (field === 'amount') {  // ✅ CHANGED from 'iecAmount'
    const numericValue = value.replace(/\D/g, '');
    setIecData(prev => ({
      ...prev,
      [field]: numericValue
    }));
  } else {
    setIecData(prev => ({
      ...prev,
      [field]: value
    }));
  }
};
// Handle Training Module file upload
const handleModuleFileUpload = async (file) => {
  if (!file) return;
  
  setModuleFileUploading(true);
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await fetch(`${api.BASE_URL}/admin/upload`, {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('authToken')
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error('Failed to upload file');
    }
    
    const data = await response.json();
    if (data && !data.error) {
      setModuleData(prev => ({
        ...prev,
        moduleFile: data.file
      }));
      alert('File uploaded successfully!');
    } else {
      throw new Error(data.message || 'Upload failed');
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    alert(`Failed to upload file: ${error.message}`);
  } finally {
    setModuleFileUploading(false);
  }
};

// Handle PLC file upload
const handlePLCFileUpload = async (file) => {
  if (!file) return;
  
  setPlcFileUploading(true);
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await fetch(`${api.BASE_URL}/admin/upload`, {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('authToken')
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error('Failed to upload file');
    }
    
    const data = await response.json();
    if (data && !data.error) {
      setPlcData(prev => ({
        ...prev,
        signedCopyFile: data.file
      }));
      alert('File uploaded successfully!');
    } else {
      throw new Error(data.message || 'Upload failed');
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    alert(`Failed to upload file: ${error.message}`);
  } finally {
    setPlcFileUploading(false);
  }
};
const handleNext = (e) => {
  e.preventDefault();
  
  // Special handling for PMU fields
  if (showPMUFields) {
    // Validate PMU-specific fields
 if (!pmuData.pmuType || !pmuData.amount || !pmuData.remarks) {  // ✅ CHANGED
  alert('Please fill all required PMU fields (Type, Amount, and Remarks).');
  return;
}
    
    // Validate basic required fields for PMU
    const pmuRequiredFields = ['instituteId', 'schemeId', 'year', 'timePeriod', 'asDate', 'asNumber', 'titleId'];
    const missingPMUFields = pmuRequiredFields.filter(field => !formData[field]);
    
    if (missingPMUFields.length > 0) {
      alert('Please fill all required basic fields before proceeding.');
      return;
    }
    
    // Month validation
    if (!formData.month) {
      alert('Please select a month before proceeding.');
      return;
    }
    
    // For PMU, skip the normal table flow and submit directly
    handlePMUSubmit();
    return;
  }
  
  // Special handling for Handholding fields
  if (showHandholdingFields) {
    // Validate Handholding-specific fields
  // Handholding validation - CHANGE handholdingAmount to amount
if (!handholdingData.numberOfDistricts || !handholdingData.numberOfInstitutions || 
    !handholdingData.amount || !handholdingData.handholdingRemarks) {  // ✅ CHANGED
  alert('Please fill all required Handholding Support fields (Number of Districts, Number of Institutions, Amount, and Remarks).');
  return;
}

    
    // Validate basic required fields for Handholding
    const handholdingRequiredFields = ['instituteId', 'schemeId', 'year', 'timePeriod', 'asDate', 'asNumber', 'titleId'];
    const missingHandholdingFields = handholdingRequiredFields.filter(field => !formData[field]);
    
    if (missingHandholdingFields.length > 0) {
      alert('Please fill all required basic fields before proceeding.');
      return;
    }
    
    // Month validation
    if (!formData.month) {
      alert('Please select a month before proceeding.');
      return;
    }
    
    // For Handholding, skip the normal table flow and submit directly
    handleHandholdingSubmit();
    return;
  }
  
  // Special handling for IEC fields
  if (showIECFields) {
    // Validate IEC-specific fields
if (!iecData.iecRemarks || !iecData.amount) {  // ✅ CHANGED
  alert('Please fill all required IEC fields (IEC Remarks and Amount).');
  return;
}
    
    // Validate basic required fields for IEC
    const iecRequiredFields = ['instituteId', 'schemeId', 'year', 'timePeriod', 'asDate', 'asNumber', 'titleId'];
    const missingIECFields = iecRequiredFields.filter(field => !formData[field]);
    
    if (missingIECFields.length > 0) {
      alert('Please fill all required basic fields before proceeding.');
      return;
    }
    
    // Month validation
    if (!formData.month) {
      alert('Please select a month before proceeding.');
      return;
    }
    
    // For IEC, skip the normal table flow and submit directly
    handleIECSubmit();
    return;
  }
  
  // Special handling for Training Module fields
  if (showModuleFields) {
    // Validate Module-specific fields (file is optional)
 // Module validation - CHANGE moduleAmount to amount
if (!moduleData.numberOfModules || !moduleData.amount || !moduleData.moduleRemarks) {  // ✅ CHANGED
  alert('Please fill all required Training Module fields (Number of Modules, Amount, and Remarks).');
  return;
}
    // Validate basic required fields for Module
    const moduleRequiredFields = ['instituteId', 'schemeId', 'year', 'timePeriod', 'asDate', 'asNumber', 'titleId'];
    const missingModuleFields = moduleRequiredFields.filter(field => !formData[field]);
    
    if (missingModuleFields.length > 0) {
      alert('Please fill all required basic fields before proceeding.');
      return;
    }
    
    // Month validation
    if (!formData.month) {
      alert('Please select a month before proceeding.');
      return;
    }
    
    // For Module, skip the normal table flow and submit directly
    handleModuleSubmit();
    return;
  }
  
  // Special handling for PLC fields
  if (showPLCFields) {
    // Validate PLC-specific fields (file is optional)
// PLC validation - CHANGE plcAmount to amount
if (!plcData.numberOfPLC || !plcData.amount || !plcData.remarks) {  // ✅ CHANGED
  alert('Please fill all PLC fields (Number of PLC, Amount, and Remarks).');
  return;
}
    // Validate basic required fields for PLC
    const plcRequiredFields = ['instituteId', 'schemeId', 'year', 'timePeriod', 'asDate', 'asNumber', 'titleId'];
    const missingPLCFields = plcRequiredFields.filter(field => !formData[field]);
    
    if (missingPLCFields.length > 0) {
      alert('Please fill all required basic fields before proceeding.');
      return;
    }
    
    // Month validation
    if (!formData.month) {
      alert('Please select a month before proceeding.');
      return;
    }
    
    // For PLC, skip the normal table flow and submit directly
    handlePLCSubmit();
    return;
  }
  
  // Regular training flow (non-PLC, non-Module, non-IEC, non-Handholding, non-PMU) starts here
  // Check if there's a balance warning and block proceeding
  if (balanceWarning) {
    alert('Cannot proceed: ' + balanceWarning);
    return;
  }
  
  // Check if there are any clientile entries
  if (confirmedClientile.length === 0) {
    alert('Please add at least one Clientele entry before proceeding.');
    return;
  }
  
  // Validate clientile totals match participants
  const validation = validateClientileTotals();
  if (!validation.isValid) {
    alert(`The sum of Clientele numbers (${validation.totalFromClientile}) must match the total number of participants (${validation.totalParticipants}).`);
    return;
  }
  
  // Check if all required fields are filled
  const requiredFields = [
    'instituteId', 'schemeId', 'year', 'timePeriod', 'asDate', 'asNumber', 'titleId', 'type',
    'shortTitle', 'participants', 'clientile', 'days', 'batches', 'amountAllocated', 
  ];
  
  // Add institution location to required fields if shown
  if (showInstitutionLocation) {
    requiredFields.push('institutionLocation');
  }
  
  // Add exposure location to required fields if shown
  if (showExposureLocation) {
    requiredFields.push('exposureLocation');
  }
  
  const missingFields = requiredFields.filter(field => !formData[field]);
  
  if (missingFields.length > 0) {
    console.log('Missing fields:', missingFields); // Debug log
    alert('Please fill all required fields before proceeding.');
    return;
  }
  
  // Month validation - month should already be set by user selection
  if (!formData.month) {
    alert('Please select a month before proceeding.');
    return;
  }
  
  // Generate initial table data
  const totalParticipants = parseInt(formData.participants);
  const totalBatches = parseInt(formData.batches);
  
  if (totalParticipants > 0 && totalBatches > 0) {
    const rows = Array.from({ length: totalBatches }, (_, index) => {
      return {
        id: index + 1,
        batchNo: (index + 1).toString().padStart(2, '0'),
        fromDate: '',
        toDate: '',
        participants: ''
      };
    });
    
    setTableData(rows);
    setShowTable(true);
  } else {
    alert('Please enter valid numbers for participants and batches.');
  }
};
// Handle IEC submission directly without batch table
const handleIECSubmit = async () => {
  setLoading(true);
  
  try {
    const selectedInstitute = institutes.find(institute => institute.id === parseInt(formData.instituteId));
    const selectedScheme = schemes.find(scheme => scheme.id === parseInt(formData.schemeId));
    const center_name = localStorage.getItem('name') || '';
    
    const finalData = {
      institute: selectedInstitute ? selectedInstitute.code : '',
      scheme: selectedScheme ? selectedScheme.code : '',
      scheme_name: selectedScheme ? selectedScheme.name : '',
      title: formData.training,
      year: formData.timePeriod === '2nd-quarter' ? formData.year.replace('-', 's') : formData.year,
      month: formData.month,
      asDate: formData.asDate,
      asNumber: formData.asNumber,
      asFile: uploadedFilePath || '',
      center_name: center_name,
      stitle: formData.shortTitle.toUpperCase(),
      type: "training",
      // IEC specific fields
      iecRemarks: iecData.iecRemarks,
      amount: iecData.amount,  // ✅ CHANGED from iecAmount
      isIEC: true
    };
    
    console.log('Submitting IEC data:', finalData);
    
    const response = await api.training.addTraining(finalData);
    
    if (response && !response.error) {
      alert('IEC training added successfully!');
      navigate('/dashboard');
    } else {
      alert(response.message || 'Error adding IEC training');
    }
  } catch (error) {
    console.error('Error submitting IEC form:', error);
    alert('Error submitting form. Please try again.');
  } finally {
    setLoading(false);
  }
};

const handleModuleSubmit = async () => {
  setLoading(true);
  
  try {
    const selectedInstitute = institutes.find(institute => institute.id === parseInt(formData.instituteId));
    const selectedScheme = schemes.find(scheme => scheme.id === parseInt(formData.schemeId));
    const center_name = localStorage.getItem('name') || '';
    
    const finalData = {
      institute: selectedInstitute ? selectedInstitute.code : '',
      scheme: selectedScheme ? selectedScheme.code : '',
      scheme_name: selectedScheme ? selectedScheme.name : '',
      title: formData.training,
      year: formData.timePeriod === '2nd-quarter' ? formData.year.replace('-', 's') : formData.year,
      month: formData.month,
      asDate: formData.asDate,
      asNumber: formData.asNumber,
      asFile: uploadedFilePath || '',
      center_name: center_name,
      stitle: formData.shortTitle.toUpperCase(),
      type: "training",
      // Training Module specific fields
      numberOfModules: moduleData.numberOfModules,
      amount: moduleData.amount,  // ✅ CHANGED from moduleAmount
      moduleRemarks: moduleData.moduleRemarks,
      moduleFile: moduleData.moduleFile || '',
      isModule: true
    };
    
    console.log('Submitting Training Module data:', finalData);
    
    const response = await api.training.addTraining(finalData);
    
    if (response && !response.error) {
      alert('Training Module added successfully!');
      navigate('/dashboard');
    } else {
      alert(response.message || 'Error adding Training Module');
    }
  } catch (error) {
    console.error('Error submitting Training Module form:', error);
    alert('Error submitting form. Please try again.');
  } finally {
    setLoading(false);
  }
};

// Handle PMU submission directly without batch table
const handlePMUSubmit = async () => {
  setLoading(true);
  
  try {
    const selectedInstitute = institutes.find(institute => institute.id === parseInt(formData.instituteId));
    const selectedScheme = schemes.find(scheme => scheme.id === parseInt(formData.schemeId));
    const center_name = localStorage.getItem('name') || '';
    
    const finalData = {
      institute: selectedInstitute ? selectedInstitute.code : '',
      scheme: selectedScheme ? selectedScheme.code : '',
      scheme_name: selectedScheme ? selectedScheme.name : '',
      title: formData.training,
      year: formData.timePeriod === '2nd-quarter' ? formData.year.replace('-', 's') : formData.year,
      month: formData.month,
      asDate: formData.asDate,
      asNumber: formData.asNumber,
      asFile: uploadedFilePath || '',
      center_name: center_name,
      stitle: formData.shortTitle.toUpperCase(),
      type: "training",
      // PMU specific fields
      pmuType: pmuData.pmuType,
      amount: pmuData.amount,  // ✅ CHANGED from expenditure
      pmuRemarks: pmuData.remarks,
      pmuFile: pmuData.pmuFile || '',
      isPMU: true
    };
    
    console.log('Submitting PMU data:', finalData);
    
    const response = await api.training.addTraining(finalData);
    
    if (response && !response.error) {
      alert('PMU training added successfully!');
      navigate('/dashboard');
    } else {
      alert(response.message || 'Error adding PMU training');
    }
  } catch (error) {
    console.error('Error submitting PMU form:', error);
    alert('Error submitting form. Please try again.');
  } finally {
    setLoading(false);
  }
};
const handlePLCSubmit = async () => {
  setLoading(true);
  
  try {
    const selectedInstitute = institutes.find(institute => institute.id === parseInt(formData.instituteId));
    const selectedScheme = schemes.find(scheme => scheme.id === parseInt(formData.schemeId));
    const center_name = localStorage.getItem('name') || '';
    
    const finalData = {
      institute: selectedInstitute ? selectedInstitute.code : '',
      scheme: selectedScheme ? selectedScheme.code : '',
      scheme_name: selectedScheme ? selectedScheme.name : '',
      title: formData.training,
      year: formData.timePeriod === '2nd-quarter' ? formData.year.replace('-', 's') : formData.year,
      month: formData.month,
      asDate: formData.asDate,
      asNumber: formData.asNumber,
      asFile: uploadedFilePath || '',
      center_name: center_name,
      stitle: formData.shortTitle.toUpperCase(),
      type: "training",
      // PLC specific fields
      numberOfPLC: plcData.numberOfPLC,
      amount: plcData.amount,  // ✅ CHANGED from plcAmount
      remarks: plcData.remarks,
      signedCopyFile: plcData.signedCopyFile,
      isPLC: true
    };
    
    console.log('Submitting PLC data:', finalData);
    
    const response = await api.training.addTraining(finalData);
    
    if (response && !response.error) {
      alert('PLC training added successfully!');
      navigate('/dashboard');
    } else {
      alert(response.message || 'Error adding PLC training');
    }
  } catch (error) {
    console.error('Error submitting PLC form:', error);
    alert('Error submitting form. Please try again.');
  } finally {
    setLoading(false);
  }
};
  // Handle table input changes from TrainingTable
  const handleTableChange = (id, field, value) => {
    const updatedData = tableData.map(row => {
      if (row.id === id) {
        return { ...row, [field]: value };
      }
      return row;
    });
    
    setTableData(updatedData);
  };

  // Progress calculation for the form completion indicator
  const calculateProgress = () => {
    const requiredFields = [
      'instituteId', 'schemeId', 'year', 'trainingId', 'type',
      'shortTitle', 'participants', 'clientile', 'days', 'batches', 'amountAllocated', 'date'
    ];
    const filledFields = requiredFields.filter(field => formData[field] !== '').length;
    return Math.round((filledFields / requiredFields.length) * 100);
  };

  // Get the name of the selected institute
  const getSelectedInstituteName = () => {
    if (formData.instituteId && institutes.length > 0) {
      const selectedInstitute = institutes.find(inst => inst.id === parseInt(formData.instituteId));
      return selectedInstitute ? selectedInstitute.name : '';
    }
    return '';
  };
  
  // Get clientile type options based on user role
  const getClientileTypeOptions = () => {
    const userRole = getUserRole();
    
    // Filter out categories that don't have options for the current role
    return clientileCategories.filter(category => {
      if (userRole === 'state' && category.SIRD && category.SIRD.length > 0) return true;
      if (userRole === 'region' && category.RIRD && category.RIRD.length > 0) return true;
      if (userRole === 'district' && category.DRCP && category.DRCP.length > 0) return true;
      return false;
    });
  };
  
  // Get clientile member options based on selected type and user role
  const getClientileMemberOptions = (typeId) => {
    if (!typeId) return [];
    
    const category = clientileCategories.find(cat => cat.id.toString() === typeId);
    if (!category) return [];
    
    const userRole = getUserRole();
    
    if (userRole === 'state') return category.SIRD || [];
    if (userRole === 'region') return category.RIRD || [];
    if (userRole === 'district') return category.DRCP || [];
    
    return [];
  };
  
  // Get category label from category ID
  const getCategoryLabel = (categoryId) => {
    const category = clientileCategories.find(cat => cat.id.toString() === categoryId);
    return category ? category.code : '';
  };

  // Add this function below the getCategoryLabel function
const validateClientileTotals = () => {
  // Calculate sum of all clientile 'nos' values
  const totalFromClientile = confirmedClientile.reduce((sum, entry) => {
    return sum + parseInt(entry.nos || 0);
  }, 0);
  
  // Get the total participants value
  const totalParticipants = parseInt(formData.participants || 0);
  
  // Return validation result
  return {
    isValid: totalFromClientile === totalParticipants,
    totalFromClientile,
    totalParticipants
  };
};

 return (
    <div className="bg-gradient-to-b from-blue-50 to-white min-h-screen py-8 px-4">
      <div className="bg-white shadow-lg rounded-xl p-8 max-w-4xl mx-auto border border-gray-100">
        {/* Header with progress */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 border-b pb-6">
          <div>
            <h2 className="text-2xl font-bold text-blue-800 mb-2">Add New Training</h2>
            {/* <p className="text-gray-600">Complete all required fields to add a new training event.</p> */}
          </div>
          <div className="mt-4 md:mt-0 w-full md:w-48">
            {/* <div className="flex justify-between text-sm mb-1">
              <span className="font-medium text-gray-700">Form Completion</span>
              <span className="font-semibold text-blue-600">{calculateProgress()}%</span>
            </div> */}
            {/* <div className="w-full bg-gray-200 rounded-full h-2.5">
              <div 
                className="bg-blue-600 h-2.5 rounded-full transition-all duration-500 ease-in-out" 
                style={{ width: `${calculateProgress()}%` }}
              ></div>
            </div> */}
          </div>
        </div>
        
        {loading && (
          <div className="text-center mb-6 p-4 bg-blue-50 rounded-lg">
            <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-3 text-blue-700 font-medium">Loading data, please wait...</p>
          </div>
        )}
        
        {!showTable ? (
          <form className="space-y-8">
            {/* Form sections with headings */}
            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Basic Information</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Display selected institute as text */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Institute
                  </label>
                  <div className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 bg-gray-50">
                    {getSelectedInstituteName()}
                  </div>
                </div>
                
                {/* Scheme Selection */}
                <div className="relative">
                  <label htmlFor="schemeId" className="block text-sm font-medium text-gray-700 mb-1">
                    Scheme <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="schemeId"
                    name="schemeId"
                    required
                    value={formData.schemeId}
                    onChange={handleChange}
                    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
                  >
                    <option value="">Select Scheme</option>
                    {schemes.map(scheme => (
                      <option key={scheme.id} value={scheme.id}>
                        {scheme.name}
                      </option>
                    ))}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
                    <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Time Period</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                
                {/* Time Period Selection - FIRST */}
                <div className="relative">
                  <label htmlFor="timePeriod" className="block text-sm font-medium text-gray-700 mb-1">
                    Time Period <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="timePeriod"
                    name="timePeriod"
                    required
                    value={formData.timePeriod}
                    onChange={handleChange}
                    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
                  >
                    <option value="1st-quarter">1st Quarter</option>
                    <option value="2nd-quarter">2nd Quarter</option>
                    <option value="3rd-quarter">3rd Quarter</option>
                    <option value="4th-quarter">4th Quarter</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
                    <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>

                {/* Year Display - SECOND (display only, not selectable) */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Year <span className="text-red-500">*</span>
                  </label>
                  <div className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 bg-gray-50">
                    {formData.year}
                  </div>
                </div>

                {/* Month Selection - THIRD */}
                <div className="relative">
                  <label htmlFor="month" className="block text-sm font-medium text-gray-700 mb-1">
                    Month <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="month"
                    name="month"
                    required
                    value={formData.month}
                    onChange={handleChange}
                    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
                  >
                    <option value="">Select Month</option>
                    {quarterMonths[formData.timePeriod]?.map((month) => (
                      <option key={month.value} value={month.value}>
                        {month.name}
                      </option>
                    ))}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
                    <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
                
              </div>
            </div>

            {/* Administrative Details */}
            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Administrative Details</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* A.S Date */}
                <div>
                  <label htmlFor="asDate" className="block text-sm font-medium text-gray-700 mb-1">
                    A.S Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    id="asDate"
                    name="asDate"
                    required
                    value={formData.asDate}
                    onChange={handleChange}
                    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
                  />
                </div>
                
                {/* A.S Number */}
                <div>
                  <label htmlFor="asNumber" className="block text-sm font-medium text-gray-700 mb-1">
                    A.S Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="asNumber"
                    name="asNumber"
                    required
                    value={formData.asNumber}
                    onChange={handleChange}
                    placeholder="Enter A.S number"
                    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
                  />
                  
                  {/* File Upload for A.S Number */}
                  <div className="mt-2">
                    <label htmlFor="asFile" className="block text-sm font-medium text-gray-700 mb-1">
                      Upload A.S File
                    </label>
                    <input
                      type="file"
                      id="asFile"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          handleFileUpload(file);
                        }
                      }}
                      disabled={fileUploading}
                      className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 disabled:opacity-50"
                    />
                    
                    {fileUploading && (
                      <div className="mt-2 flex items-center text-sm text-blue-600">
                        <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Uploading file...
                      </div>
                    )}
                    
                    {uploadedFilePath && (
                      <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded-md">
                        <div className="flex items-center text-sm text-green-700">
                          <svg className="h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          File uploaded successfully: {uploadedFilePath.split('/').pop()}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Training Details</h3>
              <div className="grid grid-cols-1 gap-6">
                {/* Training Title Selection */}
                <div className="relative">
                  <label htmlFor="titleId" className="block text-sm font-medium text-gray-700 mb-1">
                    Title of Event <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="titleId"
                    name="titleId"
                    required
                    value={formData.titleId}
                    onChange={handleChange}
                    disabled={!formData.schemeId}
                    className={`block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none ${!formData.schemeId ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  >
                    <option value="">Select Training Title</option>
                    {titles.map(title => (
                      <option key={title.id} value={title.id}>
                        {title.name}
                      </option>
                    ))}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
                    <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
{/* Conditional rendering: Show PLC fields OR Module fields OR regular training fields */}
{/* Conditional rendering: Show IEC fields OR PLC fields OR Module fields OR regular training fields */}
{/* Conditional rendering: Show PMU OR Handholding OR IEC fields OR PLC fields OR Module fields OR regular training fields */}
{showPMUFields ? (
  /* PMU-specific fields */
  <>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
      {/* PMU Type */}
      <div className="relative">
        <label htmlFor="pmuType" className="block text-sm font-medium text-gray-700 mb-1">
          Type <span className="text-red-500">*</span>
        </label>
        <select
          id="pmuType"
          value={pmuData.pmuType}
          onChange={(e) => handlePMUChange('pmuType', e.target.value)}
          className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
        >
          <option value="">Select Type</option>
          {pmuTypes.map((type, index) => (
            <option key={index} value={type}>
              {type}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
          <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </div>
      </div>
      
      {/* Expenditure */}
<div>
  <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-1">
    Amount <span className="text-red-500">*</span>
  </label>
  <input
    type="text"
    id="amount"
    value={pmuData.amount}
    onChange={(e) => handlePMUChange('amount', e.target.value)}
    placeholder="Enter amount"
    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
  />
</div>
    </div>
    
    {/* PMU Remarks */}
    <div className="mt-6">
      <label htmlFor="pmuRemarks" className="block text-sm font-medium text-gray-700 mb-1">
        Remarks <span className="text-red-500">*</span>
      </label>
      <textarea
        id="pmuRemarks"
        value={pmuData.remarks}
        onChange={(e) => handlePMUChange('remarks', e.target.value)}
        placeholder="Enter remarks"
        rows="4"
        className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
      />
    </div>
    
    {/* File Upload for PMU */}
    <div className="mt-6">
      <label htmlFor="pmuFile" className="block text-sm font-medium text-gray-700 mb-1">
        Upload File
      </label>
      <input
        type="file"
        id="pmuFile"
        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            handlePMUFileUpload(file);
          }
        }}
        disabled={pmuFileUploading}
        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 disabled:opacity-50"
      />
      
      {pmuFileUploading && (
        <div className="mt-2 flex items-center text-sm text-blue-600">
          <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Uploading file...
        </div>
      )}
      
      {pmuData.pmuFile && (
        <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded-md">
          <div className="flex items-center text-sm text-green-700">
            <svg className="h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            File uploaded successfully: {pmuData.pmuFile.split('/').pop()}
          </div>
        </div>
      )}
    </div>
  </>
) : showHandholdingFields ? (
  /* Handholding-specific fields */
  <>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
      {/* Number of Districts */}
      <div>
        <label htmlFor="numberOfDistricts" className="block text-sm font-medium text-gray-700 mb-1">
          Number of Districts <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="numberOfDistricts"
          value={handholdingData.numberOfDistricts}
          onChange={(e) => handleHandholdingChange('numberOfDistricts', e.target.value)}
          placeholder="Enter number of districts"
          className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
        />
      </div>
      
      {/* Number of Institutions */}
      <div>
        <label htmlFor="numberOfInstitutions" className="block text-sm font-medium text-gray-700 mb-1">
          Number of Institutions <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="numberOfInstitutions"
          value={handholdingData.numberOfInstitutions}
          onChange={(e) => handleHandholdingChange('numberOfInstitutions', e.target.value)}
          placeholder="Enter number of institutions"
          className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
        />
      </div>
      
      {/* Handholding Amount */}
 <div>
  <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-1">
    Amount <span className="text-red-500">*</span>
  </label>
  <input
    type="text"
    id="amount"
    value={handholdingData.amount}
    onChange={(e) => handleHandholdingChange('amount', e.target.value)}
    placeholder="Enter amount"
    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
  />
</div>
    </div>
    
    {/* Handholding Remarks */}
    <div className="mt-6">
      <label htmlFor="handholdingRemarks" className="block text-sm font-medium text-gray-700 mb-1">
        Remarks <span className="text-red-500">*</span>
      </label>
      <textarea
        id="handholdingRemarks"
        value={handholdingData.handholdingRemarks}
        onChange={(e) => handleHandholdingChange('handholdingRemarks', e.target.value)}
        placeholder="Enter remarks"
        rows="4"
        className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
      />
    </div>
    
    {/* File Upload for Handholding */}
    <div className="mt-6">
      <label htmlFor="handholdingFile" className="block text-sm font-medium text-gray-700 mb-1">
        Upload File
      </label>
      <input
        type="file"
        id="handholdingFile"
        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            handleHandholdingFileUpload(file);
          }
        }}
        disabled={handholdingFileUploading}
        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 disabled:opacity-50"
      />
      
      {handholdingFileUploading && (
        <div className="mt-2 flex items-center text-sm text-blue-600">
          <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Uploading file...
        </div>
      )}
      
      {handholdingData.handholdingFile && (
        <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded-md">
          <div className="flex items-center text-sm text-green-700">
            <svg className="h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            File uploaded successfully: {handholdingData.handholdingFile.split('/').pop()}
          </div>
        </div>
      )}
    </div>
  </>
) : showIECFields ? (
  /* IEC-specific fields */
  <>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
      {/* IEC Amount */}
<div>
  <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-1">
    Amount <span className="text-red-500">*</span>
  </label>
  <input
    type="text"
    id="amount"
    value={iecData.amount}
    onChange={(e) => handleIECChange('amount', e.target.value)}
    placeholder="Enter amount"
    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
  />
</div>

    </div>
    
    {/* IEC Remarks */}
    <div className="mt-6">
      <label htmlFor="iecRemarks" className="block text-sm font-medium text-gray-700 mb-1">
        IEC Remarks <span className="text-red-500">*</span>
      </label>
      <textarea
        id="iecRemarks"
        value={iecData.iecRemarks}
        onChange={(e) => handleIECChange('iecRemarks', e.target.value)}
        placeholder="Enter IEC remarks"
        rows="4"
        className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
      />
    </div>
  </>
) : showPLCFields ? (
  /* PLC-specific fields */
  <>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
      {/* Number of PLC */}
      <div>
        <label htmlFor="numberOfPLC" className="block text-sm font-medium text-gray-700 mb-1">
          Number of PLC <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="numberOfPLC"
          value={plcData.numberOfPLC}
          onChange={(e) => handlePLCChange('numberOfPLC', e.target.value)}
          placeholder="Enter number of PLC"
          className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
        />
      </div>
      
      {/* PLC Amount */}
<div>
  <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-1">
    Amount <span className="text-red-500">*</span>
  </label>
  <input
    type="text"
    id="amount"
    value={plcData.amount}
    onChange={(e) => handlePLCChange('amount', e.target.value)}
    placeholder="Enter amount"
    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
  />
</div>
    </div>
    
    {/* Remarks */}
    <div className="mt-6">
      <label htmlFor="remarks" className="block text-sm font-medium text-gray-700 mb-1">
        Remarks <span className="text-red-500">*</span>
      </label>
      <textarea
        id="remarks"
        value={plcData.remarks}
        onChange={(e) => handlePLCChange('remarks', e.target.value)}
        placeholder="Enter remarks"
        rows="4"
        className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
      />
    </div>
    
    {/* File Upload for Signed Copy */}
    <div className="mt-6">
      <label htmlFor="signedCopyFile" className="block text-sm font-medium text-gray-700 mb-1">
        Upload Signed Copy
      </label>
      <input
        type="file"
        id="signedCopyFile"
        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            handlePLCFileUpload(file);
          }
        }}
        disabled={plcFileUploading}
        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 disabled:opacity-50"
      />
      
      {plcFileUploading && (
        <div className="mt-2 flex items-center text-sm text-blue-600">
          <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Uploading file...
        </div>
      )}
      
      {plcData.signedCopyFile && (
        <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded-md">
          <div className="flex items-center text-sm text-green-700">
            <svg className="h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            File uploaded successfully: {plcData.signedCopyFile.split('/').pop()}
          </div>
        </div>
      )}
    </div>
  </>
) : showModuleFields ? (
  /* Training Module-specific fields */
  <>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
      {/* Number of Modules */}
      <div>
        <label htmlFor="numberOfModules" className="block text-sm font-medium text-gray-700 mb-1">
          Number of Training Modules <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="numberOfModules"
          value={moduleData.numberOfModules}
          onChange={(e) => handleModuleChange('numberOfModules', e.target.value)}
          placeholder="Enter number of modules"
          className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
        />
      </div>
      
      {/* Module Amount */}
<div>
  <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-1">
    Amount <span className="text-red-500">*</span>
  </label>
  <input
    type="text"
    id="amount"
    value={moduleData.amount}
    onChange={(e) => handleModuleChange('amount', e.target.value)}
    placeholder="Enter amount"
    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
  />
</div>
    </div>
    {/* Module Remarks */}
    <div className="mt-6">
      <label htmlFor="moduleRemarks" className="block text-sm font-medium text-gray-700 mb-1">
        Remarks <span className="text-red-500">*</span>
      </label>
      <textarea
        id="moduleRemarks"
        value={moduleData.moduleRemarks}
        onChange={(e) => handleModuleChange('moduleRemarks', e.target.value)}
        placeholder="Enter remarks"
        rows="4"
        className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
      />
    </div>
    
    {/* File Upload for Module */}
    <div className="mt-6">
      <label htmlFor="moduleFile" className="block text-sm font-medium text-gray-700 mb-1">
        Upload File
      </label>
      <input
        type="file"
        id="moduleFile"
        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            handleModuleFileUpload(file);
          }
        }}
        disabled={moduleFileUploading}
        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 disabled:opacity-50"
      />
      
      {moduleFileUploading && (
        <div className="mt-2 flex items-center text-sm text-blue-600">
          <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Uploading file...
        </div>
      )}
      
      {moduleData.moduleFile && (
        <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded-md">
          <div className="flex items-center text-sm text-green-700">
            <svg className="h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            File uploaded successfully: {moduleData.moduleFile.split('/').pop()}
          </div>
        </div>
      )}
    </div>
  </>
) : (
  /* Regular training fields */
  <>
    {/* Type Selection */}
    <div className="relative">
      <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1">
        Type <span className="text-red-500">*</span>
      </label>
      <select
        id="type"
        name="type"
        required
        value={formData.type}
        onChange={handleChange}
        className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
      >
        <option value="">Select Type</option>
        {trainingTypes.map(type => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </div>
    </div>

    {/* Toggle for Auto-Calculate */}
    <div className="flex justify-end items-center mb-3 mt-3">
      <span className="text-xs text-gray-500 mr-2">Manual</span>
      <button
        type="button"
        onClick={handleToggleAutoCalculate}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${autoCalculate ? 'bg-blue-600' : 'bg-gray-200'}`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${autoCalculate ? 'translate-x-6' : 'translate-x-1'}`}
        />
      </button>
      <span className="text-xs text-gray-500 ml-2">Auto</span>
      <span className="ml-2 text-xs text-gray-600">
        {autoCalculate ? 'Auto-calculate amount based on participants and days' : 'Manually enter amount'}
      </span>
    </div>

    {/* Arrange No. of Participants, Days, Batches, Amount Allocated in horizontal line */}
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      {/* Number of Participants */}
      <div>
        <label htmlFor="participants" className="block text-sm font-medium text-gray-700 mb-1">
          No. of Participants <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="participants"
          name="participants"
          required
          value={formData.participants}
          onChange={handleChange}
          placeholder="Enter number of participants"
          className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
        />
      </div>
          
      {/* Days */}
      <div>
        <label htmlFor="days" className="block text-sm font-medium text-gray-700 mb-1">
          Days <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="days"
          name="days"
          required
          value={formData.days}
          onChange={handleChange}
          placeholder="Enter number of days"
          className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
        />
      </div>
          
      {/* Batches */}
      <div>
        <label htmlFor="batches" className="block text-sm font-medium text-gray-700 mb-1">
          Batches <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="batches"
          name="batches"
          required
          value={formData.batches}
          onChange={handleChange}
          placeholder="Enter number of batches"
          className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
        />
      </div>

      {/* Amount Allocated */}
      <div>
        <label htmlFor="amountAllocated" className="block text-sm font-medium text-gray-700 mb-1">
          Amount Allotted <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="amountAllocated"
          name="amountAllocated"
          required
          value={formData.amountAllocated}
          onChange={handleChange}
          readOnly={autoCalculate}
          className={`block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 ${autoCalculate ? 'bg-gray-50 cursor-not-allowed' : 'focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50'}`}
        />

        {/* Add Balance Loading and Warning Display */}
        {balanceLoading && (
          <div className="mt-2 flex items-center text-sm text-blue-600">
            <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Checking balance...
          </div>
        )}

        {balanceWarning && (
          <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-md">
            <div className="flex">
              <svg className="h-5 w-5 text-red-400 mr-2 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              <div className="text-sm text-red-700">
                {balanceWarning}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>

    {/* Institution Location for Leadership Management Programme (state only) */}
    {showInstitutionLocation && (
      <div className="mt-6">
        <label htmlFor="institutionLocation" className="block text-sm font-medium text-gray-700 mb-1">
          Institution Location <span className="text-red-500">*</span>
        </label>
        <select
          id="institutionLocation"
          name="institutionLocation"
          required
          value={formData.institutionLocation}
          onChange={handleChange}
          className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
        >
          <option value="">Select Institution</option>
          {institutionOptions.map((institution, index) => (
            <option key={index} value={institution}>
              {institution}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
          <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </div>
      </div>
    )}

    {/* Exposure Location for Exposure Visit - Outside State (state only) */}
    {showExposureLocation && (
      <div className="mt-6">
        <label htmlFor="exposureLocation" className="block text-sm font-medium text-gray-700 mb-1">
          Location <span className="text-red-500">*</span>
        </label>
        <select
          id="exposureLocation"
          name="exposureLocation"
          required
          value={formData.exposureLocation}
          onChange={handleChange}
          className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
        >
          <option value="">Select Location</option>
          {exposureLocationOptions.map((location, index) => (
            <option key={index} value={location}>
              {location}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
          <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </div>
      </div>
    )}

    {/* Simplified Clientile Section */}
    <div className="mt-6">
      <h4 className="text-md font-medium text-gray-700 mb-3">Clientele <span className="text-red-500">*</span></h4>
      
      {/* Display for already added clientile entries */}
      {confirmedClientile.length > 0 && (
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-4">
          {confirmedClientile.map((entry) => (
            <div key={entry.id} className="flex justify-between items-start mb-2 pb-2 border-b border-gray-200 last:border-0 last:mb-0 last:pb-0">
              <div className="flex-1">
                <div className="text-sm font-medium">{entry.typeLabel} - {entry.nos}</div>
                <div className="text-sm text-gray-600">{entry.member}</div>
              </div>
              <button
                type="button"
                onClick={() => removeConfirmedClientile(entry.id)}
                className="p-1 text-red-500 hover:bg-red-50 rounded-full"
                aria-label="Remove entry"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          ))}
        </div>
      )}

      {confirmedClientile.length > 0 && (
        <div className="mt-2 pt-2 border-t border-gray-200">
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600">
              Total Clientele Count: <span className="font-semibold">{validateClientileTotals().totalFromClientile}</span>
            </span>
            <span className={`text-sm ${validateClientileTotals().isValid ? 'text-green-600' : 'text-red-600'}`}>
              {validateClientileTotals().isValid 
                ? '✓ Matches participant count' 
                : `✗ Should match participant count (${formData.participants})`}
            </span>
          </div>
        </div>
      )}

      {/* Simple form for adding clientile entries */}
      <div className="bg-white p-4 rounded-lg border border-gray-200">
        <div className="grid grid-cols-12 gap-4">
          {/* Type Dropdown */}
          <div className="col-span-5 relative">
            <label htmlFor="clientileType" className="block text-sm text-gray-700 mb-1">Type</label>
            <select
              id="clientileType"
              value={clientileInput.type}
              onChange={(e) => setClientileInput({...clientileInput, type: e.target.value, typeLabel: getCategoryLabel(e.target.value)})}
              className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
            >
              <option value="">Select Type</option>
              {getClientileTypeOptions().map(category => (
                <option key={category.id} value={category.id.toString()}>
                  {category.code}
                </option>
              ))}
            </select>
          </div>
          
          {/* Member Dropdown */}
          <div className="col-span-5 relative">
            <label htmlFor="clientileMember" className="block text-sm text-gray-700 mb-1">Member</label>
            <select
              id="clientileMember"
              value={clientileInput.member}
              onChange={(e) => setClientileInput({...clientileInput, member: e.target.value})}
              disabled={!clientileInput.type}
              className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
            >
              <option value="">Select Member</option>
              {getClientileMemberOptions(clientileInput.type).map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
          
          {/* Nos Input */}
          <div className="col-span-2">
            <label htmlFor="clientileNos" className="block text-sm text-gray-700 mb-1">Nos</label>
            <input
              id="clientileNos"
              type="text"
              value={clientileInput.nos}
              onChange={(e) => {
                const numericValue = e.target.value.replace(/\D/g, '');
                setClientileInput({...clientileInput, nos: numericValue});
              }}
              placeholder="No."
              className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
            />
          </div>
          
          {/* Add Button */}
          <div className="col-span-12 mt-3">
            <button
              type="button"
              onClick={addClientileEntry}
              disabled={!clientileInput.type || !clientileInput.member || !clientileInput.nos}
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-300 disabled:cursor-not-allowed"
            >
              Add Clientele
            </button>
          </div>
        </div>
      </div>
    </div>
  </>
)}
              </div>
            </div>
            
            {/* Form action buttons with improved styling */}
            <div className="pt-6 border-t border-gray-200">
              <div className="flex flex-col-reverse sm:flex-row justify-end space-y-4 space-y-reverse sm:space-y-0 sm:space-x-4">
                <button
                  type="button"
                  onClick={() => navigate('/dashboard')}
                  className="px-5 py-2.5 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleNext}
                disabled={balanceWarning && !showPLCFields && !showModuleFields}
                  className={`px-5 py-2.5 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
                    (balanceWarning && !showPLCFields)
                      ? 'bg-gray-400 cursor-not-allowed' 
                      : 'bg-blue-600 hover:bg-blue-700'
                  } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors flex items-center justify-center`}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
{(balanceWarning && !showPLCFields && !showModuleFields && !showPMUFields) ? 'Cannot Proceed - Balance Issue' : (showPMUFields ? 'Submit PMU' : showPLCFields ? 'Submit PLC' : showModuleFields ? 'Submit Module' : showIECFields ? 'Submit IEC' : showHandholdingFields ? 'Submit Handholding' : 'Next')}
                </button>
              </div>
            </div>
          </form>
        ) : (
          <TrainingTable 
            tableData={tableData} 
            handleTableChange={handleTableChange} 
            onBack={() => setShowTable(false)} 
            loading={loading}
            setLoading={setLoading}
            formData={formData}
            institutes={institutes}
            schemes={schemes}
            trainings={trainings}
            uploadedFilePath={uploadedFilePath}
          />
        )}
      </div>
    </div>
  );
};

export default TrainingForm;